const version = 'v1'
const VITE_ENV = import.meta.env
export const storageNamespace = 'mss-' + VITE_ENV.MODE
export const manage = `/manage/api/${version}`
export const wayline = `/wayline/api/${version}`
export const media = `/media/api/${version}`
export const apiConfig = {
  protocol: VITE_ENV.VITE_API_PROTOCOL,
  host: VITE_ENV.VITE_BASE_URL,
  port: VITE_ENV.VITE_BASE_PORT,
  mode: VITE_ENV.MODE,
  modeName: VITE_ENV.MODE === 'development' ? 'DEV' : VITE_ENV.MODE === 'production' ? 'PROD' : 'TEST',
  clientId: VITE_ENV.VITE_CLIENT_ID,
  alipayClientId: VITE_ENV.VITE_ALIPAY_CLIENT_ID,
  // MODE 取值只会是 development/production/test，不会是 'dev'，
  // 之前的三元判断永远走 else 分支，等价于恒为 '/prod-api'
  AERIAL_PREFIX: '/prod-api',
  AERIAL_VERSION: '2401',
  AERIAL_BUILD: '',
  WX_APPID: VITE_ENV.VITE_WX_APPID,
  WX_MP_APPID: VITE_ENV.VITE_WX_MP_APPID,
  RESERVATION_TEMPLATE_ID: VITE_ENV.VITE_WX_OPEN_SUBSCRIBE_RESERVATION_TEMPLATE_ID,
  FLIGHTOK_TEMPLATE_ID: VITE_ENV.VITE_WX_OPEN_SUBSCRIBE_FLIGHTOK_TEMPLATE_ID,
  AMAP_KEY: VITE_ENV.VITE_AMAP_KEY,
  AMAP_SECURITY_JS_CODE: VITE_ENV.VITE_AMAP_SECURITY_JS_CODE,
}
export const IS_DEV = VITE_ENV.MODE === 'development'
export const imageUrlPrefix = window.location.protocol + '//' + window.location.host